import env from "src/core/env";
import { Repository } from "src/core/Repository";
import { AllParentFieldsResponse } from "src/models/directorys/directory";
import { getAllDeliveryReportRequest } from "src/models/phongs/DeliveryReport";
import { ITypeClassify } from "src/models/phongs/TypeClassify";
import { DeleteRequest } from "src/models/Request";

class TypeClassifyReportRepository extends Repository {
  protected basePath = "/api/cms-service/type-classify-report";

  constructor() {
    super(env.API_CMS_URL);
  }

  getAll(params: getAllDeliveryReportRequest) {
    return this.request<AllParentFieldsResponse>({
      method: "GET",
      url: "/all",
      params,
    });
  }

  createTypeClassify(params: ITypeClassify) {
    return this.request({
      method: "POST",
      url: "",
      data: params,
    });
  }

  exportTypeClassify(id: string) {
    return this.request({
      method: "POST",
      url: `/${id}/export`,
    });
  }

  deleteTypeClassify(param: DeleteRequest) {
    return this.request({
      method: "DELETE",
      url: `/${param.id}`,
    });
  }

  updateTypeClassify(params: ITypeClassify) {
    return this.request({
      method: "PUT",
      url: "",
      data: params,
    });
  }
}
export const typeClassifyReportRepository = new TypeClassifyReportRepository();
